<template>
  <div :class="[isMobile ? 'parentHistoryMobile' : 'parentHistory']">
    <v-btn
      color="primary white--text"
      :class="[isMobile ? 'historyButtonMobile' : 'historyButton']"
      rounded
      @click="$emit('clicked')"
    >
      {{ title != null ? title : "مشاهده سوابق" }}
    </v-btn>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["title"],
  components: {
    appRow: DetailRow,
  },

  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  methods: {
    goToRoute() {},
  },
};
</script>
<style >
.historyButton {
  width: unset !important;
  min-width: 200px !important;
}
.historyButtonMobile {
  margin: 10px auto;
  margin-right: unset !important;
  width: 100% !important;
}

.parentHistory {
  display: inline-flex;
  padding: 20px;
}
.parentHistoryMobile {
  display: grid;
  padding: 10px 30px 0 30px;
}
</style>
